const cns = [

{label:"Type(s) of disorder:",
controlType:"checkbox group",
options:["Motor", "Sensory", "Tremor", "Co-ordination loss", "Speech","Visual", "Hearing", "Smell/ taste", "Cognitive", "Mood","Memory"]
},

{label:"Symptomatic side (if relevant):",
controlType:"radio button",
options:["Right", "Left", "Bilateral"],
},

{label:"Site(s):",
controlType:"checkbox group",
options:["arm(s)", "leg(s)", "head"],
},

{label:"Power (affected side):",
controlType:"radio button",
options:["Normal", "Decreased", "Abscent"],
},

{label:"Tone (affected side):",
controlType:"radio button",
options:["Normal", "Decreased", "Increased"]
},

{label:"Reflexes (affected side):",
controlType:"radio button",
options:["Normal", "Increased", "Decreased", "Abscent"],
},

{label:"Plantar reflex (affected side):",
controlType:"radio button",
options:["Flexor", "Extensor", "Abscent"],
},
{label:"Present for several:",
controlType:"radio button",
options:["Days", "Weeks","Months","Years"]
},

{label:"Other description of condition:",
controlType:"text area",
options:[],
},



]

export default cns